module.exports = __webpack_public_path__ + "static/img/308.b8f3e37.png";


//////////////////
// WEBPACK FOOTER
// ./src/module/productSpring/images/308.png
// module id = 517
// module chunks = 3